import Vue from 'vue'
import * as uiv from 'uiv'

Vue.use(uiv)
